// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__187XQ","content":"GlobalSearch_content__1PLFs"};